module.exports = __webpack_public_path__ + "static/media/hover_image_map.ec241607.png";